import { Button, Modal } from "react-bootstrap";
import { ReassuranceModalProps, ReassuranceModalRemoveBarProps } from "../interfaces/Timeline";

export function ReassuranceModalRemoveBar(props: ReassuranceModalRemoveBarProps) {
  return (
    <Modal
      show={props.showReassuranceModal}
      onHide={() => props.setShowReassuranceModal(false)}
    >
      <Modal.Header closeButton>
        <Modal.Title>Delete bar</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Do you really want to delete this bar? <br /> All patterns in this bar will be deleted too!</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            props.setShowReassuranceModal(false);
          }}
        >
          No
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            props.setShowReassuranceModal(false);
            props.removeBar(props.barToRemove);
          }}
        >
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
